import React, { Component } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import LoadingButton from "@mui/lab/LoadingButton";
import ErrorIcon from "@mui/icons-material/Error";
import { withSnackbar } from './../../../hocs/withSnackbar';
import { withRouter } from 'react-router-dom';
import userService from "../../../services/userService";

class SettingsSecurity extends Component {
  state = {
    password: "",
    confirmPassword: "",
    error: "",
    updateLoading: false
  };

  update = async () => {
    const { password, confirmPassword } = this.state;
    this.setState({
      updateLoading: true,
      error: ""
    })
    const { showMessage } = this.props;
    setTimeout(async () => {
      try {
        const response = await userService.updatePassword(password, confirmPassword);
        this.setState({
            error: "",
            updateLoading: false
        })
        showMessage("Updated security info")
      } catch (err) {
        console.log(err)
        this.setState({
          error: err?.response?.data?.message
            ? err.response.data.message
            : "An error occurred",
            updateLoading: false
        });
      }
    }, 500)
  }

  render() {
    const { password, confirmPassword, error, updateLoading } = this.state;
    return (
      <div
        style={{
          padding: "10px 20px",
        }}
      >
        <h3
          style={{
            padding: "0 16px",
          }}
        >
          Security
        </h3>
        <TableContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Password:</TableCell>
                <TableCell>
                  <TextField
                    variant="standard"
                    InputProps={{
                      style: {
                        fontFamily: "inherit",
                      },
                    }}
                    type="password"
                    value={password}
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Confirm password:</TableCell>
                <TableCell>
                  <TextField
                    variant="standard"
                    InputProps={{
                      style: {
                        fontFamily: "inherit",
                      },
                    }}
                    type="password"
                    value={confirmPassword}
                    onChange={(event) =>
                      this.setState({ confirmPassword: event.target.value })
                    }
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div
              style={{
                display: "flex",
                justifyContent: error ? "space-between" : "flex-end",
                marginTop: 20,
                padding: "0 16px",
              }}
            >
              {error && (
                <div
                  style={{
                    fontSize: 15,
                    color: "red",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <ErrorIcon
                    style={{
                      marginRight: 10,
                    }}
                  />
                  {error}
                </div>
              )}
              <LoadingButton
                loadingPosition="start"
                loading={updateLoading}
                variant="contained"
                startIcon={<RocketLaunchIcon />}
                style={{
                  backgroundColor: "var(--theme-orange)",
                }}
                onClick={() => this.update()}
              >
                Update
              </LoadingButton>
            </div>
      </div>
    );
  }
}

export default withSnackbar(SettingsSecurity);
